import React from 'react';
import { Box, IBoxProps } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { Absolute } from '..';
import { Z_FG } from '../utilities/zIndex';

export type PortalOverlayHeaderProps = {
  alignItems?: string,
  renderTitle?: () => any;
  renderLeftAction?: () => any;
  renderRightAction?: () => any;
  hideBottomBorder?: boolean;
} & IBoxProps;

export default function PortalOverlayHeader({
  renderTitle,
  renderLeftAction,
  renderRightAction,
  hideBottomBorder,
  ...restProps
}: PortalOverlayHeaderProps) {
  return (
    <Box
      minHeight={45}
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      borderBottomWidth={hideBottomBorder ? 0 : 1}
      borderStyle="solid"
      borderBottomColor={colors.lightGrey}
      {...restProps}
      testID="portal-overlay-header"
    >
      {typeof renderLeftAction === 'function' && (
        <Absolute
          top={0}
          left={0}
          bottom={0}
          zIndex={Z_FG}
          justifyContent="center"
        >
          {renderLeftAction()}
        </Absolute>
      )}
      {typeof renderTitle === 'function' && renderTitle()}
      {typeof renderRightAction === 'function' && (
        <Absolute
          top={0}
          right={0}
          bottom={0}
          zIndex={Z_FG}
          justifyContent="center"
        >
          {renderRightAction()}
        </Absolute>
      )}
    </Box>
  );
}
